import isMobile from 'ismobilejs';

export default function useIsMobile() {
  return isMobile(window.navigator).any;
}
